export default __webpack_public_path__ + "static/media/emoji-laugh.ebdc15fe.webp";